var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "back-profile",
        {
          nativeOn: {
            click: function($event) {
              return _vm.navigateTo("app.profile.home")
            }
          }
        },
        [_vm._v("Perfil de " + _vm._s(_vm.studentProfile.student.name))]
      ),
      _vm._v(" "),
      _c(
        "block",
        {
          staticStyle: { "padding-bottom": "30px" },
          attrs: { "bordered-header": true }
        },
        [
          _c("template", { slot: "header" }, [_vm._v("Información adicional")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-sections" },
            _vm._l(_vm.sections, function(section) {
              return _c(
                "div",
                { key: section.title, staticClass: "info-section" },
                [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "info-section-title is-uppercase has-text-weight-medium"
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(section.title) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-items" },
                    _vm._l(section.items, function(item) {
                      return _c("div", { key: item.name }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.name && item.value,
                                expression: "item.name && item.value"
                              }
                            ],
                            staticClass: "info-item"
                          },
                          [
                            _c("div", { staticClass: "item-field" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-content" }, [
                              _vm._v(_vm._s(item.value))
                            ])
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            }),
            0
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }